<div class="controls-zone" [ngClass]="drawLeftBorder ? 'with-left-border' : 'no-left-border'" *ngrxLet="session$ as session">
  @if (session && !session.tempUser) {
    @if (enableNotifications) {
      <alg-notification-bell></alg-notification-bell>
    }
    <alg-top-right-menu [styleClass]="topRightMenuStyleClass"></alg-top-right-menu>
  } @else {
    @if (languages.length > 1) {
      <alg-language-picker class="lang-button"></alg-language-picker>
    }
    <button
      class="large-icon sign-in-button"
      icon="ph-fill ph-user-circle"
      (click)="login()"
      alg-button
      [disabled]="isLoginButtonClicked()"
      i18n
    >Sign in</button>
  }
</div>
